// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

function getBlocks( children ) {
	return children[0].blocks[1].children.filter( el => el.$element );
}

function extractElement( blocks ) {
	return blocks.map( block => block.$element );
}

function getPriceMin( blocks ) {
	const isPro = window.customerIsPro;

	const productRegex = /[\(pro\)][\(directeur\-ams\)]/;
	const singleUnitRegex = /\d+\+$/;

	function getVariants( blocks ) {
		return blocks.map( block => block.data.variants );
	}

	function filterVariantsForPro( variants ) {
		return variants.filter( variant => isPro ? productRegex.test( variant.title ) : !!!productRegex.test( variant.title ) );
	}

	function filterVariantsForSingleUnit( variants ) {
		return variants.filter( variant => !singleUnitRegex.test( variant.title ) )
	}

	function getPrices( variants ) {
		return variants.map( variant => Number( variant.price ) );
	}

	const variants = getVariants( blocks );
	const prices = variants.map( variant => {
		const filteredVariants = filterVariantsForPro( variant );
		const singleUnitVariants = filterVariantsForSingleUnit( filteredVariants );
		return getPrices( singleUnitVariants );
	} );

	return prices.map( price => price.length ? Math.min( ...price ) : price );
}

( function () {
	BoostPFS.inject( this );

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function () {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;

		function getSaneNumber( number ) {
			let n = number;
			if ( typeof n !== 'number' ) return null;
			const priceString = n.toString();
			const priceArray = priceString.split( '.' );

			if ( priceArray.length === 1 ) {
				return `${priceArray[0]}.00`;
			} else {
				if ( priceArray[1].length === 1 ) {
					return `${priceArray[0]}.${priceArray[1]}0`;
				} else {
					return `${priceArray[0]}.${priceArray[1]}`;
				}
			}
		}

		const blocks = getBlocks( this.children );
		const elements = extractElement( blocks );
		const priceMin = getPriceMin( blocks );
		const priceElements = elements.map( ( [element, _] ) => {
			return element.querySelector( '.boost-pfs-search-suggestion-product-regular-price' ) || element.querySelector( '.boost-pfs-search-suggestion-product-sale-price' );
		} ).filter( Boolean );

		priceElements.map( ( element, index ) => {
			const price = getSaneNumber( priceMin[index] );

			if ( price === null ) return;

			element.innerHTML = price;
		} );
	};


	/* start-boost-custom */
	/* #boost-80362: Hide products based on tag */
	InstantSearchApi.beforeCall = function ( searchTerm ) {
		if ( !boostPFSConfig.customer_tags || boostPFSConfig.customer_tags.indexOf( 'directeur-ams' ) == -1 ) {
			Globals.instantSearchQueryParams.h_options = ['exclu'];
		}

        // Start Boost 184541
        if (boostPFSConfig.customer.tags) {          
          if (!boostPFSConfig.customer.tags.includes("pro") && boostPFSConfig.customer.tags !== null) {
            Globals.instantSearchQueryParams.tag = ['not_pro'];	 
          }
        } else {
          Globals.instantSearchQueryParams.tag = ['not_pro'];	 
        }
        // End Boost 184541
	}
	/* end-boost-custom */


  Utils.buildProductItemUrl = function(data, hasCollection) {
      // console.log('buildProductItemUrl');
      // Get url information
      var params = Utils.getWindowLocation().search.substring(1);
      var pathname = window.location.pathname;
      var elements = pathname.split('/');
    
      // Check if has locale
      var localeURLPart = "";
      var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
      if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
        localeURLPart = Shopify.routes.root.replace(/\/$/, '');
      } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
        localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
      }
    
      // Get product handle
      var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
      var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
      if (hasCollection) {
        // Homepage or Search page
        if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
          var preHandle = localeURLPart + '/collections/all/products/';
          return preHandle + handle;
    
          // Tag Page
        } else if (Utils.isTagPage()) {
          var preHandle = localeURLPart + '/collections/';
          var collectionHandleIndex = elements.indexOf("collections") + 1
          if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
          return '/collections/all/products/' + handle;
        } else {
          // Google cache URL
          // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
          if (params.indexOf('cache:') > -1) {
            var collectionHandle = 'all';
            var temp = params.split('&')[0].split('?')[0].split('collections/');
            if (temp.length > 1) {
              if (temp[1].indexOf('/') > -1) {
                collectionHandle = temp[1].split('/')[0];
              } else {
                collectionHandle = temp[1];
              }
            }
            collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
            return '/collections/' + collectionHandle + '/products/' + handle;
          }
          var collectionHandleIndex = elements.indexOf("collections") + 1;
          var preHandle = localeURLPart + '/collections/';
          
          if (typeof elements[2] !== 'undefined') {
            // Build for collection pages
            if ((localeURLPart == '' && elements[1] === 'collections') || localeURLPart != '') {
              return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
            }
            //Build for other pages, use collection/all
            return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
          } else if (typeof elements[2] === 'undefined' && localeURLPart == '') {
            return '/products/' + handle;
          }
          return window.location.pathname + '/products/' + handle;
        }
      }
      return localeURLPart + '/products/' + handle;
    };
  
  
} )();